import { render, staticRenderFns } from "./manualType.vue?vue&type=template&id=41bd3828"
import script from "./manualType.vue?vue&type=script&lang=js"
export * from "./manualType.vue?vue&type=script&lang=js"
import style0 from "./manualType.vue?vue&type=style&index=0&id=41bd3828&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports